<template>
	<div class="common-loading" v-if="loadingShow">
		<img src="./images/loading.gif">
	</div>
</template>
<script>
export default {
  	name: "loading",
	data:function(){
		return {
            loadingShow:false,
		}
	},
	created:function(){
		window.loading = this;
	},
};
</script>
<style lang="scss">
@import "./index.scss";
</style>
